export default "__VITE_ASSET__35cdc218__"